import { URI } from '~/types/adamTypes';
import type { NomadDB } from '~/db/NomadDB';

export const getExportCoachingStatsPromises = async (
  db: NomadDB,
  nomadFetch: Function,
  multiProgressionLimit: number = 1
): Promise<void> => {
  let coachingStats = await db.coachingStats.where({ local: 1 }).toArray();

  coachingStats = coachingStats.map((coachingStat) => {
    const cs = { ...coachingStat };
    if (cs.objectiveValue == null) cs.objectiveValue = '';
    delete cs.local;
    delete cs.total;
    return cs;
  });

  const chunkSize = multiProgressionLimit;

  const chunks = [];

  for (let i = 0; i < coachingStats.length; i += chunkSize) {
    chunks.push(coachingStats.slice(i, i + chunkSize));
  }

  const getChunksPromise = async (chunk): Promise<void> => {
    try {
      await nomadFetch(URI.CoachingStats, {
        method: 'POST',
        body: chunk[0],
      });
      const params = chunk.map((c) => [
        c.appId,
        c.historyDateUTC,
        c.member,
        c.isTotal ? 1 : 0,
      ]);
      await db.coachingStats
        .where('[appId+historyDateUTC+member+total]')
        .anyOf(params)
        .modify({ local: 0 });
      // await await db.coachingStats.where('id').anyOf(ids).modify({ local: 0 });
    } catch (e) {
      console.error('Export coachingStats ::', e);
    }
  };

  const getPromises = (): Promise<void>[] => {
    const promises = [];
    chunks.forEach((chunk) => {
      promises.push(getChunksPromise(chunk));
    });
    return promises;
  };

  const promises = getPromises();
  if (promises.length) {
    await Promise.all(promises);
  }
};
